export const enum MessageKeyTypes {
  FUNCTION = 'function',
  OBJECT = 'object'
}

export const enum MessageKeyAnalytics {
  ANALYTICS = 'Analytics'
}
